import React from 'react';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import Overlay from './components/Overlay/Overlay';
import styles from './App.module.scss';
import { permissionScreenConstants } from './pages/auth/constants/AuthConstants';
import notificationPermissionGif from './assets/images/notificationsPermissions.gif';

export interface AppBlockerOverlayParams {
  isOpen: boolean;
}

const NotificationsBlockerOverlay = (params: AppBlockerOverlayParams) => {
  const { isOpen } = params;
  return (
    <div>
      {isOpen && (
        <Overlay visible={isOpen}>
          <div className={styles.blockerOverlay}>
            <header>
              <Typography variant={'h1'}>{permissionScreenConstants.title}</Typography>
            </header>
            <div className={styles.content}>
              <Typography variant={'h3'}>{permissionScreenConstants.instructions}</Typography>
              <img
                onLoad={(event: any) => event.target?.classList?.add(styles['animate'])}
                src={notificationPermissionGif}
                alt="Login"
              />
            </div>
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default NotificationsBlockerOverlay;
